export interface GetCollectionAndUserCheckRequest {
  branchCode: string
  lendType: string
}

export function GetCollectionAndUserCheckRequestToJSON(
  value: GetCollectionAndUserCheckRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    lend_type: value.lendType !== '' ? value.lendType : undefined
  }
}
